// Lucide icon: eye-off (https://lucide.dev/icons/eye-off)
import { EyeOff } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconHide = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <EyeOff />
    </IconComponentStyled>
  )
}
